import React from "react";
import styles from "../popup.module.scss";
export default function MobileEdit({ strings, objectToSave, handleInputChange, validateInput, error, }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", { className: "heading1" },
            strings.edit,
            " ",
            strings.mobile),
        React.createElement("p", null, strings.editDescription),
        React.createElement("div", { className: "input-group" },
            React.createElement("label", { htmlFor: "newMobilePhoneNumber" },
                strings.mobile,
                ":"),
            React.createElement("input", { name: "newMobilePhoneNumber", type: "text", value: objectToSave.newMobilePhoneNumber, onChange: handleInputChange, onBlur: (e) => validateInput(e.target.name) }),
            React.createElement("span", { className: styles.error }, error.newMobilePhoneNumberErr)),
        React.createElement("div", { className: "input-group" },
            React.createElement("label", { htmlFor: "confirmationPassword" },
                strings.password,
                ":"),
            React.createElement("input", { name: "confirmationPassword", type: "password", value: objectToSave.confirmationPassword, onChange: handleInputChange, onBlur: (e) => validateInput(e.target.name) }),
            React.createElement("span", { className: styles.error }, error.confirmationPasswordErr))));
}
